// src/config/seo/pageMetadata.js
// Meta tags e SEO para cada página - centralizado e fácil de manter

const pageMetadata = {
  '/': {
    title: 'Hortaliças no Atacado em Embu-Guaçu | Verde Musgo Natural',
    description:
      'Fornecedor de hortaliças e folhosas sem agrotóxicos no atacado em Embu-Guaçu e região. Entregas diretas para restaurantes, lanchonetes e hortifrutis com frescor, qualidade e zero desperdício.',
    keywords:
      'hortaliças no atacado, hortaliças em Embu-Guaçu, fornecedor de hortaliças em Embu-Guaçu, folhosas sem agrotóxicos, atacado de hortaliças, hortaliças para restaurantes, hortaliças para lanchonetes, hortaliças Itapecerica da Serra, hortaliças Taboão da Serra, hortaliças São Lourenço da Serra, hortaliças Juquitiba, hortaliças zona sul SP, hortaliças zona oeste SP, Verde Musgo Natural',
    ogImage: '/images/og-home.jpg',
    ogType: 'website',
    canonical: 'https://verdemusgonatural.com.br'
  },

  '/hortalicas': {
    title: 'Hortaliças no Atacado para Restaurantes e Hortifrutis | Verde Musgo Natural',
    description:
      'Fornecedor de hortaliças frescas e folhosas sem agrotóxicos para restaurantes, lanchonetes, hotéis, hortifrutis e cozinhas industriais em Embu-Guaçu, Itapecerica da Serra, Taboão da Serra, São Lourenço da Serra, Juquitiba e região de São Paulo.',
    keywords:
      'hortaliças no atacado, hortaliças para restaurantes, fornecedor de hortaliças, hortaliças certificadas, hortaliças frescas, folhosas sem agrotóxicos, hortaliças Embu-Guaçu, hortaliças Itapecerica da Serra, hortaliças Taboão da Serra, hortaliças São Lourenço da Serra, hortaliças Juquitiba, atacado de verduras, fornecedor hortifrutis',
    ogImage: '/images/og-hortalicas.jpg',
    ogType: 'product',
    canonical: 'https://www.verdemusgonatural.com.br/hortalicas'
  },

  '/loja-online': {
    title: 'Loja Online | Compre Alimentos Saudáveis | Verde Musgo Natural',
    description:
      'Loja online com produtos agroecológicos frescos. Alimentos naturais entregues em São Paulo. Sem agrotóxicos, com qualidade garantida.',
    keywords: 'comprar alimentos orgânicos online, loja alimentos naturais, alimentos saudáveis, entrega São Paulo',
    ogImage: '/images/og-loja.jpg',
    ogType: 'ecommerce',
    canonical: 'https://verdemusgonatural.com.br/loja-online'
  },

  '/morangos': {
    title: 'Morangos em Fertirrigação | Fornecedor B2B | Verde Musgo Natural',
    description:
      'Morangos de alta qualidade em fertirrigação, sem agrotóxicos. Fornecimento no atacado para pequenos comércios. Qualidade superior garantida.',
    keywords: 'morangos fertirrigação, fornecedor morangos atacado, morangos naturais, B2B alimentos',
    ogImage: '/images/og-morangos.jpg',
    ogType: 'product',
    canonical: 'https://verdemusgonatural.com.br/morangos'
  },

  '/turismo': {
    title: 'Turismo Rural em São Paulo | Visite Nossa Propriedade | Verde Musgo Natural',
    description:
      'Turismo rural com atividades na natureza: visita à horta, colhe e pague, pesca, acampamento. Próximo a São Paulo, em ambiente agroecológico.',
    keywords: 'turismo rural São Paulo, visita propriedade rural, colhe e pague, pesca, acampamento',
    ogImage: '/images/og-turismo.jpg',
    ogType: 'event',
    canonical: 'https://verdemusgonatural.com.br/turismo'
  },

  '/sobre': {
    title: 'Sobre Verde Musgo Natural | Nossa História & Valores',
    description: 'Conheça a história de Verde Musgo Natural, nossos valores e compromisso com a sustentabilidade e qualidade.',
    keywords: 'sobre verde musgo natural, história, valores, sustentabilidade',
    ogImage: '/images/og-sobre.jpg',
    ogType: 'website',
    canonical: 'https://verdemusgonatural.com.br/sobre'
  },

  '/certificacoes': {
    title: 'Certificações | Verde Musgo Natural',
    description:
      'Certificação agroecológica estadual de São Paulo. Conheça nossos compromissos com a qualidade e sustentabilidade.',
    keywords: 'certificação agroecológica, certificação orgânica, qualidade produtos',
    ogImage: '/images/og-certificacoes.jpg',
    ogType: 'website',
    canonical: 'https://verdemusgonatural.com.br/certificacoes'
  },

  '/contato': {
    title: 'Entre em Contato | Verde Musgo Natural',
    description: 'Fale conosco via WhatsApp ou preencha nosso formulário de contato. Estamos prontos para tirar suas dúvidas.',
    keywords: 'contato, whatsapp, formulário contato',
    ogImage: '/images/og-contato.jpg',
    ogType: 'website',
    canonical: 'https://verdemusgonatural.com.br/contato'
  }
};

export default pageMetadata;
